import React, { useState } from 'react';
import { Box, Tab, Tabs, TextField } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/pro-light-svg-icons';
import MyStudySidekick from '../../common/MyStudySidekick';
import { ResourceList } from './ResourceList';
import { MobileGenerateResourceMenu } from './MobileGenerateResourceMenu';
import { RESOURCE_TYPES } from '../helpers/resourceTypes';

/**
 * The phone dashboard: one search box and a tab per kind of resource, over a
 * single scrolling list. The search and tabs stay put while the list scrolls.
 *
 * Props:
 *   id (string) - ID prefix for generated element IDs.
 */
export const MobileResourceBrowser = ({ id }) => {
  const [activeTypeId, setActiveTypeId] = useState(RESOURCE_TYPES[0].id);
  const [searchTerm, setSearchTerm] = useState('');

  const activeType = RESOURCE_TYPES.find((type) => type.id === activeTypeId);

  return (
    <Box className="mobileBrowser" id={`${id}__mobileBrowser`}>
      <Box className="mobileBrowserHeader">
        <MyStudySidekick component="h1" className="title" id={`${id}__title`} />

        <TextField
          id={`${id}__textField_search`}
          className="mobileSearch"
          size="small"
          fullWidth
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder={`Search ${activeType.pluralLabel.toLowerCase()}`}
          slotProps={{
            input: {
              endAdornment: <FontAwesomeIcon icon={faMagnifyingGlass} className="searchIcon" />,
            },
            htmlInput: { 'aria-label': `Search ${activeType.pluralLabel.toLowerCase()}` },
          }}
        />

        <Tabs
          className="mobileTabs"
          value={activeTypeId}
          onChange={(_e, nextId) => setActiveTypeId(nextId)}
          variant="fullWidth"
          aria-label="Resource type"
        >
          {RESOURCE_TYPES.map(({ id: typeId, pluralLabel }) => (
            <Tab key={typeId} value={typeId} label={pluralLabel} id={`${id}__tab_${typeId}`} />
          ))}
        </Tabs>
      </Box>

      {/* Remounts per tab so each list loads its own resources. */}
      <ResourceList
        key={activeTypeId}
        id={`${id}__${activeTypeId}`}
        resourceType={activeType}
        searchTerm={searchTerm}
      />

      <MobileGenerateResourceMenu id={id} />
    </Box>
  );
};
